import type { JSX } from "react";
import { InputSwitch } from "primereact/inputswitch";
import { classNames } from "primereact/utils";
import { useTranslation } from "react-i18next";
import { UiInputSwitchProps } from "../../models/components/input-switch.model";

const UiInputSwitch = (props: UiInputSwitchProps): JSX.Element => {
	const { t } = useTranslation("common");

	return (
		<div className={classNames("k-input-container", props.removeBottomSpacer && "mb-0")}>
			<div className="k-inputswitch-container">
				{/* Input */}
				<InputSwitch
					{...props}
					placeholder={props?.placeholder ? t(props.placeholder) : undefined}
					className={classNames(props.className)}
					checked={props.checked ?? false}
					onChange={props.onChange}
					onBlur={props.onBlur}
				/>

				{props.label && (
					<label
						htmlFor={props.id}
						className={classNames("k-inputswitch-label")}
					>
						{t(props.label)}
					</label>
				)}
			</div>
		</div>
	);
};

export default UiInputSwitch;
